export default __webpack_public_path__ + "static/media/BEHANCE_ico.9eebac19.svg";